@if (shouldShowArrows) {
  @let disabled = scrollingDisabled() || leftScrollingDisabled();
  <div
    class="scroll-button"
    matRipple
    [matRippleDisabled]="disabled"
    [class.disabled]="disabled"
    (click)="scrollLeft()"
  >
    <mat-icon class="material-symbols-outlined"> arrow_left </mat-icon>
  </div>
}

<div
  class="tabs-container"
  (scroll)="updateLeftOrRightScrollingDisabled()"
  #tabsContainer
>
  @for (output of outputs; track output) {
    <h3-output-tab
      [output]="output"
      [showOutputName]="output.name === visibleOutputName"
      [selected]="(selectedOutputName$ | async) === output.name"
      matRipple
    ></h3-output-tab>
  }
</div>

@if (shouldShowArrows) {
  @let disabled = scrollingDisabled() || rightScrollingDisabled();
  <div
    class="scroll-button"
    matRipple
    [matRippleDisabled]="disabled"
    [class.disabled]="disabled"
    (click)="scrollRight()"
  >
    <mat-icon class="material-symbols-outlined"> arrow_right </mat-icon>
  </div>
}
